import React from 'react'
import { Row, Col } from 'react-bootstrap'

import RFFFields from '../../react-final-form-fields'

import { nameofFactory, getPlaceholderTextFromLabel } from '../../../../util'

import { ISafetyCaseFilterFormFieldsProps, ISafetyCaseFilterValues } from './safety-case-filter-form-types'
import useSafetyCaseFilterQueries from './use-safety-case-filter-queries'

const nameof = nameofFactory<ISafetyCaseFilterValues>()

const startedDateRangeLabel = 'Started Date Range'
const statusLabel = 'Status'
const tagsLabel = 'Labels'
const originatedFromSafetyReportLabel = 'Originated From Safety Report'

const SafetyCaseFilterFormFields: React.FC<ISafetyCaseFilterFormFieldsProps> = props => {
  const { disabled, isDateRangeDisabled, dateRangeInfo } = props

  const {
    statusOptions,
    statusesQuery,
    tagsOptions,
    tagsQuery,
    booleanSearchOptions,
  } = useSafetyCaseFilterQueries()

  return (
    <>
      <Row>
        <Col>
          <RFFFields.DateRangePicker
            name={nameof('startedDateRange')}
            label={startedDateRangeLabel}
            placeholderText={getPlaceholderTextFromLabel(startedDateRangeLabel)}
            disabled={disabled || isDateRangeDisabled}
            info={dateRangeInfo}
            isDateOnly
          />
        </Col>

        <Col>
          <RFFFields.Select
            name={nameof('statusIds')}
            label={statusLabel}
            isMulti
            placeholderText={getPlaceholderTextFromLabel(statusLabel)}
            disabled={disabled || statusesQuery?.isFetching}
            options={statusOptions}
          />
        </Col>

        <Col>
          <RFFFields.Select
            name={nameof('searchTagIds')}
            label={tagsLabel}
            isMulti
            placeholderText={getPlaceholderTextFromLabel(tagsLabel)}
            disabled={disabled || tagsQuery?.isFetching}
            options={tagsOptions}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <RFFFields.Select
            name={nameof('originatedFromSafetyReport')}
            label={originatedFromSafetyReportLabel}
            options={booleanSearchOptions}
            disabled={disabled}
          />
        </Col>

        <Col></Col>
      </Row>
    </>
  )
}

export default SafetyCaseFilterFormFields
